import { render, staticRenderFns } from "./PendingOrders.vue?vue&type=template&id=484f3c7c"
import script from "./PendingOrders.vue?vue&type=script&lang=ts"
export * from "./PendingOrders.vue?vue&type=script&lang=ts"
import style0 from "./PendingOrders.vue?vue&type=style&index=0&id=484f3c7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports